import { ConstBlock } from './ConstBlock';
import { VarAssignBlock } from './VarAssignBlock';

/**
 * A variable creation block. Creates an empty array.
 */
export class ArrayCreateBlock extends VarAssignBlock {

    /**
     * Constructor
     * @param id the id of statenode
     * @param varName name of the array
     */
    constructor(id: string, varName: string) {
        super(id, varName, [new ConstBlock(id, [])]);
    }

}